<template>
  <div id="honour">
    <div class="container">
      <div class="home_item_content">
        <h6>Honor and certification</h6>
        <i></i>
        <h1>荣誉与认证</h1>
      </div>

      <div>
        <div class="cert_img" v-viewer>
          <div class="cert_img_item">
            <div class="img_box">
              <img src="../../assets/images/cert_1.png" alt />
            </div>
            <p>高新技术企业证书</p>
          </div>
          <div class="cert_img_item">
            <div class="img_box">
              <img src="../../assets/images/cert_2.png" alt />
            </div>
            <p>陕西省AAA级信誉单位</p>
          </div>
          <div class="cert_img_item">
            <div class="img_box">
              <img src="../../assets/images/cert_3.png" alt />
            </div>
            <p>中国互联网协会理事单位</p>
          </div>
          <div class="cert_img_item">
            <div class="img_box">
              <img src="../../assets/images/cert_4.png" alt />
            </div>
            <p>诚信经营签约单位</p>
          </div>
          <div class="cert_img_item">
            <div class="img_box">
              <img src="../../assets/images/cert_5.png" alt />
            </div>
            <p>创业企业观察点</p>
          </div>
          <div class="cert_img_item"></div>
          <div class="cert_img_item huawei">
            <img src="../../assets/images/cert_6.jpg" alt />
            <p>华为技术认证书</p>
          </div>
          <div class="cert_img_item huawei">
            <img src="../../assets/images/cert_7.jpg" alt />
            <p>华为技术认证书</p>
          </div>
          <div class="cert_img_item huawei"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
#honour {
  .container {
    width: 1200px;
    margin: 0 auto 109px;
    .home_item_content {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 200px 0 40px;
      h6 {
        font-size: 14px;
        line-height: 20px;
        text-transform: uppercase;
      }
      i {
        display: block;
        height: 4px;
        width: 40px;
        background: rgba(38, 172, 255, 1);
        margin: 8px 0;
      }
      h1 {
        font-size: 36px;
        line-height: 50px;
        font-weight: 500;
      }
    }
    .cert_img {
      display: flex;
      flex-wrap: wrap;
      .huawei {
        img {
          width: 384px;
        }
      }
      .cert_img_item {
        flex: 33%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .img_box {
          width: 384px;
          height: 270px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(222, 222, 222, 1);
          padding: 20px;
        }
        p {
          text-align: center;
          margin-top: 30px;
          margin-bottom: 30px;
        }
      }
    }
  }
}
</style>